import { stringifyUrl } from '@shared/utils/route';

import { get, post } from '../..';

export const fetchAgreementsByEmployee = (groupId, employeeId, date) =>
  get(
    stringifyUrl(
      `/v1/schedule/agreements/by-group/${groupId}/by-employee/${employeeId}`,
      { date },
    ),
  );

export const fetchAgreementsByEmployeeDateRange = (
  groupId,
  employeeId,
  fromDate,
  toDate,
) =>
  get(
    stringifyUrl(
      `/v1/schedule/agreements/by-group/${groupId}/by-employee/${employeeId}/by-date-range`,
      {
        fromDate,
        toDate,
      },
    ),
  );

export const fetchAgreementsByIds = ({
  groupId,
  agreementIds,
  startDateTime,
  endDateTime,
}) =>
  post(`/v1/employee/by-group/${groupId}/slim-agreement/by-ids`, {
    ids: agreementIds,
    period: {
      startDateTime,
      endDateTime,
    },
  });

export const fetchAgreementTemplatesForPeriod = (
  startDateTime,
  endDateTime,
  groupId,
) =>
  get(
    stringifyUrl(
      `/v1/employee/agreement-templates/by-group/${groupId}/for-workers`,
      {
        startDateTime,
        endDateTime,
      },
    ),
  );

export const fetchAllAgreementsByEmployee = (employeeId) =>
  get(`/v1/employee/${employeeId}/agreements`);

export const fetchAllAgreementsByEmployeeInBaseSchedule = (
  groupId,
  employeeId,
) =>
  get(
    `/v1/baseschedule/templates/agreements/by-group/${groupId}/by-employee/${employeeId}`,
  );
